export function convertMinutesToTimeJp(minutes: number){
  const hours = Math.floor(minutes / 60)
  var realMinute = minutes - hours * 60
  // 時間
  return `${hours}時間${realMinute}分`
}